module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }, [_c('h1', {
    staticClass: "m-label"
  }, [_vm._v("指導報告書")]), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-th"
    },
    slot: "tr-th"
  }, [_c('th-c', [_vm._v("id")]), _vm._v(" "), _c('th-c', [_vm._v("student_tutor_id")]), _vm._v(" "), _c('th-c', [_vm._v("user_id")]), _vm._v(" "), _c('th-c', [_vm._v("month")]), _vm._v(" "), _c('th-c', [_vm._v("filing_date")]), _vm._v(" "), _c('th-c', [_vm._v("note")]), _vm._v(" "), _c('th-c', [_vm._v("作成日")]), _vm._v(" "), _c('th-c', [_vm._v("更新日")])], 1), _vm._v(" "), _c('tr-c', {
    attrs: {
      "slot": "tr-td"
    },
    slot: "tr-td"
  }, [_c('td-c', [_vm._v(_vm._s(_vm.report.id))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.report.student_tutor_id))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.report.user_id))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.report.month))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.report.filing_date))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.report.note))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.report.created_at))]), _vm._v(" "), _c('td-c', [_vm._v(_vm._s(_vm.report.updated_at))])], 1)], 1), _vm._v(" "), (_vm.report.id) ? [_c('iframe', {
    attrs: {
      "src": _vm.files + _vm.report.id + '_r.pdf',
      "frameborder": "0"
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1160464a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Report/Report.vue
// module id = 1291
// module chunks = 0